import moment from "moment";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { NOTIFICATION_MESSAGE_TYPE } from "../../constants";
import MESSAGES from "../../constants/Messages";
import { sendEmailForAssistance } from "../../utils/ExceptionHandlingUtil";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "../LoadingIndicator";
import { CustomPopup } from "../../common/Popup/CustomPopup";

export const sendAlternateRouteEnquiryEmail = async (
	selectedDestination,
	selectedOrigin,
	shippingDate,
	shippingItem,
	setNotificationMessage,
	setNotificationType,
	additionalSccs,
	errorCode,
	totalGrossWeight,
	totalVolume,
	setIsLoading,
	t,
	callBackFn
) => {
	const getReason = () => {
		switch (errorCode) {
			case "ER044":
				return "current capacity constraints.";
			case "ER047":
				return "shipment dimensions constraints.";
			case "ER046":
				return "other constraints.";
			default:
				return "restrictions";
		}
	};

	const getSccs = (additionalSccs) => {
		if (additionalSccs && additionalSccs.length) {
			return additionalSccs.map((e) => e.scc).toString();
		} else {
			return null;
		}
	};

	const attributes = [
		{
			key: "origin",
			value: selectedOrigin ? selectedOrigin.code : null,
		},
		{
			key: "destination",
			value: selectedDestination ? selectedDestination.code : null,
		},
		{
			key: "shippingItem",
			value:
				shippingItem && shippingItem?.description && shippingItem?.product
					? `${shippingItem?.description}-${shippingItem?.product}`
					: null,
		},
		{
			key: "shippingDate",
			value: shippingDate ? moment(shippingDate).format("DD MMM YYYY") : null,
		},
		{
			key: "sccs",
			value: getSccs(additionalSccs),
		},
		{
			key: "totalGrossWeight",
			value: totalGrossWeight,
		},
		{
			key: "totalVolume",
			value: totalVolume,
		},
		{
			key: "enquiryReason",
			value: getReason(),
		},
	];

	const replacements = {
		"%ORG%": selectedOrigin ? selectedOrigin.code : "",
		"%DES%": selectedDestination ? selectedDestination.code : "",
		"%REASON%": getReason(),
	};

	const response = await sendEmailForAssistance(
		"ALTERNATE_ROUTING_ENQUIRY",
		setIsLoading,
		attributes,
		replacements
	);

	callBackFn?.();

	if (response) {
		setNotificationMessage(t(MESSAGES.ASSISTANCE_MSG, { ns: "errors" }));
		setNotificationType(NOTIFICATION_MESSAGE_TYPE.INFO);
	} else {
		setIsLoading(false);
		setNotificationMessage(t(MESSAGES.MAIL_ASSISTANCE_FAILS, { ns: "errors" }));
		setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
	}
};

const AlternateRouteEnquiryPopup = ({
	setShowEmailEnquiryPopup,
	selectedDestination,
	selectedOrigin,
	shippingDate,
	shippingItem,
	setNotificationMessage,
	setNotificationType,
	additionalSccs,
	errorCode,
	totalGrossWeight,
	totalVolume,
}) => {
	const { t } = useTranslation(["labels"]);
	const [isLoading, setIsLoading] = useState(false);

	const handleCancel = () => {
		setShowEmailEnquiryPopup({
			isOpen: false,
			errorCode: null,
		});
	};

	const handleConfirm = async () => {
		await sendAlternateRouteEnquiryEmail(
			selectedDestination,
			selectedOrigin,
			shippingDate,
			shippingItem,
			setNotificationMessage,
			setNotificationType,
			additionalSccs,
			errorCode,
			totalGrossWeight,
			totalVolume,
			t,
			setIsLoading,
			() => {
				setShowEmailEnquiryPopup({
					isOpen: false,
					errorCode: null,
				});
			}
		);
	};


	return (
		<div className="cargo-portal-container dialog-container">
			<CustomPopup
				footerPriBtnLabel={t('COMMON.SEND_ENQUIRY')}
				footerPriBtnClick={handleConfirm}
				headerComponent={{ mainHeader: t("BOOKING.ASSISTANCE_HEAD") }}
				isVisible
				footerSecBtnLabel={t('COMMON.GO_BACK')}
				footerSecBtnClick={handleCancel}
				onClose={handleCancel}
				body={<p className="mt-2">{t("BOOKING.ALTERNATE_ROUTE_ENQUIRY")}</p>}
			/>
			{isLoading && <LoadingIndicator />}
		</div>
	);
};

export default AlternateRouteEnquiryPopup;
